import { createAsyncThunk } from "@reduxjs/toolkit";
import { AddChildOrganizationsParams, AddContactsParams, DeleteParams, SearchParams } from "../model/organization";
import * as services from "../services/organizationService";

export const fetchOrganizations = createAsyncThunk("organizationManager/fetchOrganizations", () => 
    services.fetchOrganizations()
);

export const searchOrganizations = createAsyncThunk(
    "organizationManager/searchOrganizations",
    async (params: SearchParams) => {
        const searchResult = await services.searchOrganizations(params);
        return {
            ...searchResult,
            ...params,
        };
    }
);

export const fetchOrganizationById = createAsyncThunk("organizationManager/fetchOrganizationById", (orgId?: string) =>
    services.fetchOrganizationById(orgId)
);

export const updateOrganization = createAsyncThunk(
    "organizationManager/updateOrganization",
    async (org: any, { rejectWithValue }) => {
        try {
            const response = await services.updateOrganization(org);
            return response;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const deleteOrganizations = createAsyncThunk(
    "organizationManager/deleteOrganizations",
    async (params: DeleteParams): Promise<any> => {
        await services.deleteOrganizations(params.organizationIds, params.mode);
        const searchParams = {
            query: params.query,
            sortField: params.sortField,
            sortType: params.sortType,
            startIndex: params.startIndex,
            recordsToRetrieve: params.recordsToRetrieve,
        };
        const searchResult = await services.searchOrganizations(searchParams);
        return {
            ...searchResult,
            ...searchParams,
        };
    }
);

export const fetchContactsInOrganization = createAsyncThunk(
    "organizationManager/fetchContactsInOrganization",
    (orgId: string) => services.fetchContactsInOrganization(orgId)
);

export const addContactsToOrganization = createAsyncThunk(
    "organizationManager/AddCustomerContactsToOrganization",
    async (params: AddContactsParams) => {
        await services.AddContactsToOrganization(params);
        const contacts = services.fetchContactsInOrganization(params.organizationId);
        return contacts;
    }
);

export const fetchChildOrganizations = createAsyncThunk(
    "childOrganizationList/fetchChildOrganizations",
    (parentOrganizationId: string) => services.fetchChildOrganizations(parentOrganizationId)
);

export const addChildOrganizationsToOrganization = createAsyncThunk(
    "childOrganizationList/addChildOrganizationsToOrganization",
    async (params: AddChildOrganizationsParams, { rejectWithValue }) => {
        try {
            await services.addChildOrganizationsToOrganization(params);
            const childOrganizations = services.fetchChildOrganizations(params.parentOrganizationId);
            return childOrganizations;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);
